import produce from 'immer';
import { combineReducers } from 'redux';
import { ProcessAction, ProcessActionType } from '../../actions/processActions';

const loading = (state = false, action: ProcessAction) => {
  switch (action.type) {
    case ProcessActionType.LIST_PROCESS_STATUSES:
      return true;
    case ProcessActionType.LIST_PROCESS_STATUSES_OK:
    case ProcessActionType.LIST_PROCESS_STATUSES_ERROR:
      return false;
    default:
      return state;
  }
};

const loadingError = (state = '', action: ProcessAction) => {
  switch (action.type) {
    case ProcessActionType.LIST_PROCESS_STATUSES:
      return '';
    case ProcessActionType.LIST_PROCESS_STATUSES_ERROR:
      return action.error;
    default:
      return state;
  }
};

type LoadingState = { loading: boolean; loadingError: string };
type ResetState = { resetting: boolean; resetError: string };

export type ProcessStatusState = LoadingState & ResetState;

interface ProcessStatusesById {
  [id: string]: ProcessStatusState;
}

const byId = (state: ProcessStatusesById = {}, action: ProcessAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ProcessActionType.GET_PROCESS_STATUS: {
        draft[action.processId] = {
          ...draft[action.processId],
          loading: true,
          loadingError: '',
        };
        break;
      }
      case ProcessActionType.GET_PROCESS_STATUS_ERROR: {
        draft[action.processId].loading = false;
        draft[action.processId].loadingError = action.error;
        break;
      }
      case ProcessActionType.GET_PROCESS_STATUS_OK: {
        draft[action.processId].loading = false;
        break;
      }
      case ProcessActionType.RESET_PROCESS_STATUS: {
        draft[action.processId] = {
          ...draft[action.processId],
          resetting: true,
          resetError: '',
        };
        break;
      }
      case ProcessActionType.RESET_PROCESS_STATUS_ERROR: {
        draft[action.processId].resetting = false;
        draft[action.processId].resetError = action.error;
        break;
      }
      case ProcessActionType.RESET_PROCESS_STATUS_OK: {
        draft[action.processId].resetting = false;
        break;
      }
      case ProcessActionType.LIST_PROCESS_STATUSES_OK: {
        action.data.forEach((proc) => {
          draft[proc.id] = {} as ProcessStatusState;
        });

        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  loading,
  loadingError,
  byId,
});
